import { Stack, IconButton } from '@mui/material';
import type { GetApprovalFlowInvoicesListResponse } from '@vy/api-definition';
import { VyIcon } from '@vy/ui-design-system';
import type { ItemOf } from '@vy/utils';
import { isEmptyArray, isNotEmptyArray, validateNotNullOrUndefined } from '@vy/utils';
import { isValidInvoicePosition, NOT_FOUND_INDEX } from './ApprovalFlowHeader';

type InvoiceNavigationArrowsProps = {
  invoicePosition?: number;
  invoiceData?: GetApprovalFlowInvoicesListResponse;
  onInvoiceChange?: (newInvoice: ItemOf<GetApprovalFlowInvoicesListResponse>) => void;
};

export const InvoiceNavigationArrows: React.FC<InvoiceNavigationArrowsProps> = ({
  onInvoiceChange,
  invoiceData,
  invoicePosition = NOT_FOUND_INDEX,
}) => {
  const handleArrowClick = (direction: 'left' | 'right') => {
    if (!isValidSwitch(invoicePosition, invoiceData)) {
      return;
    }
    validateNotNullOrUndefined(invoiceData);
    const nextPosition = direction === 'left' ? invoicePosition - 1 : invoicePosition + 1;
    const invoiceToSwitch = invoiceData[nextPosition];

    onInvoiceChange?.(invoiceToSwitch);
  };

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        justifyContent: "space-between"
      }}>
      <IconButton
        disableRipple
        onClick={() => handleArrowClick('left')}
        disabled={invoicePosition === 0 || !isValidInvoicePosition(invoicePosition)}
        sx={{
          borderRadius: 1,
          width: '36px',
          height: '36px',
        }}
      >
        <VyIcon icon="ArrowSmallLeft" />
      </IconButton>
      <IconButton
        disableRipple
        onClick={() => handleArrowClick('right')}
        disabled={isEmptyArray(invoiceData) || invoicePosition === invoiceData.length - 1}
        sx={{
          borderRadius: 1,
          width: '36px',
          height: '36px',
        }}
      >
        <VyIcon icon="ArrowSmallRight" />
      </IconButton>
    </Stack>
  );
};

function isValidSwitch(invoicePosition?: number, invoiceData?: GetApprovalFlowInvoicesListResponse) {
  return isNotEmptyArray(invoiceData) && isValidInvoicePosition(invoicePosition);
}
